import { render, staticRenderFns } from "./OrderQueue.vue?vue&type=template&id=49284977&scoped=true"
import script from "./OrderQueue.vue?vue&type=script&lang=js"
export * from "./OrderQueue.vue?vue&type=script&lang=js"
import style0 from "./OrderQueue.vue?vue&type=style&index=0&id=49284977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49284977",
  null
  
)

export default component.exports